import { render, staticRenderFns } from "./AdminTableButton.vue?vue&type=template&id=05016aa8&scoped=true&"
import script from "./AdminTableButton.vue?vue&type=script&lang=js&"
export * from "./AdminTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05016aa8",
  null
  
)

export default component.exports